import { LogoutOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { logout } from 'src/actions';
import { MButton } from 'src/lib';

export const LogoutButton = () => {
  const dispatch = useDispatch();

  return (
    <MButton
      type='tertiary'
      danger
      onClick={() => {
        dispatch(logout());
      }}>
      <LogoutOutlined />
      <span>Logout</span>
    </MButton>
  );
};
